import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import "./ApplicationMycommittee.scss";
import Loading from "../components/Loading";
import { MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
import axios from "axios";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { ControlPointSharp } from "@mui/icons-material";
import { set } from "react-hook-form";
import Swal from "sweetalert2";

function ApplicationMycommittee() {
  let navigate = useNavigate();

  const [tempData, setTemptData] = useState([]);
  const [committeeFile, setCommitteeFile] = useState(""); // 위원회 파일
  const [typeId, setTypeId] = useState("");
  const [commDescription, setCommDescription] = useState("");

  // 토큰, decode id
  const token = window.sessionStorage.getItem("token");
  const id = jwtDecode(token).sub;

  // 신청내역 조회
  useEffect(() => {
    (async () => {
      await axios.get(`/api/committee-member/${id}/doc`).then((response) => {
        // console.log(response);
        setTemptData(response.data);
      });
    })();
  }, []);
  // 파일 업로드
  const onUploadSubmit = (value) => async (e) => {
    setVisible(true);
    e.preventDefault();
    setCommitteeFile(e.target.files);
    setTypeId(e.target.id);
    setCommDescription(e.target.getAttribute("comment"));

    const uploadFile = committeeFile[0];
    const formData = new FormData();
    formData.append("files", e.target.files[0]);
    formData.append(
      "doc",
      JSON.stringify({
        parentId: id,
        parentType: "COMMITTEE_MEMBER",
        description: e.target.getAttribute("comment"),
        comment: value,
      })
    );
    axios({
      headers: {
        "Content-Type": "multipart/form-data",
      },
      method: "post",
      url: `/api/committee-member/${id}/doc`,
      data: formData,
    })
      .then((response) => {
        setCommitteeFile("");
        setTypeId("");
        setCommDescription("");
        Swal.fire({
          icon: "success",
          title: "완료",
          text: "업로드완료",
          confirmButtonColor: "dodgerBlue",
          iconColor: "dodgerBlue",
        });
        setVisible(false);
      })
      .catch((error) => {
        setVisible(false);

        console.log(error);
        console.log(error);
      });
  };
  // Loading 핸들러
  const [visible, setVisible] = useState(false);
  return (
    <>
      <div className="my_commitee_inout">
        {visible && <Loading visible={visible} />}
        <div className="my_commitee_inout_wrap">
          <table className="table_wrap">
            <thead>
              <tr>
                <th>평가서 및 체크리스트</th>
                <th>업로드/변경날짜</th>
                <th>다운로드</th>
                <th>파일선택</th>
              </tr>
            </thead>
            <tbody>
              {tempData.map((value) => {
                return (
                  <tr key={value.id}>
                    <td className="">{value.comment}</td>
                    <td className="">
                      {value.updateAt.substring(0, 11).replace(/-/g, ".")}
                    </td>
                    <td className="">
                      <button className="btn_color">
                        <a
                          href={`/api/committee-member/${id}/doc/${value.id}`}
                          download
                          style={{ color: "white" }}
                        >
                          다운로드
                        </a>
                      </button>
                    </td>
                    <td className="">
                      <div
                        className="input_wrap file_input_wrap"
                        style={{
                          backgroundColor: "white",
                          height: "34px",
                        }}
                      >
                        <input
                          className="input_box file_input"
                          type="file"
                          id={value.id}
                          style={{
                            visibility: "hidden",
                            width: "30px",
                          }}
                          comment={value.description}
                          onClick={(e) => (e.target.value = null)}
                          onChange={onUploadSubmit(value.comment)}
                        />
                        <label
                          htmlFor={value.id}
                          className="file_label"
                          style={{
                            height: "100%",
                            borderRadius: "3px",
                            padding: "0 1rem",
                            fontWeight: "600",
                            fontSize: "14px",
                            wordBreak: "keep-all",
                            marginLeft: "25px",
                          }}
                        >
                          파일업로드
                        </label>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ApplicationMycommittee;
